// @flow
import moment from 'moment';
import mergeDateAndTime from '../helpers/mergeMoment';

export const TIME_FORMAT = 'HH:mm:ss.SSSS';

export type OverlapMode = 'INCLUSIVE' | 'EXCLUSIVE';

class TimeRange {

  start: moment;
  end: moment;

  constructor(start: moment, end: moment) {
    this.start = start.clone();
    this.end = end.clone();
  }

  getStart(): moment {
    return this.start.clone();
  }

  getEnd(): moment {
    return this.end.clone();
  }

  overlaps(other: TimeRange, overlapMode: OverlapMode = 'INCLUSIVE'): boolean {
    const startOnSameDate = mergeDateAndTime(this.end, other.start);
    const endOnSameDate = mergeDateAndTime(this.start, other.end);

    if (overlapMode === 'EXCLUSIVE') {
      return !(this.start.isSameOrAfter(endOnSameDate) || this.end.isSameOrBefore(startOnSameDate));
    }

    return !(this.start.isAfter(endOnSameDate) || this.end.isBefore(startOnSameDate));
  }

  // TODO - verify if it works... seems to only compare hours
  isSame(other: TimeRange): boolean {
    return other.start.isSame(this.start, 'hour') && other.end.isSame(this.end, 'hour');
  }

  toISO(): { start: string, end: string } {
    return {
      start: this.start.format(TIME_FORMAT),
      end: this.end.format(TIME_FORMAT),
    };
  }

  static fromISO({ start, end }: { start: string, end: string }): TimeRange {
    return new TimeRange(moment(start, TIME_FORMAT), moment(end, TIME_FORMAT));
  }

  static default() {
    return new TimeRange(moment(), moment());
  }
}

export default TimeRange;



// WEBPACK FOOTER //
// ./src/common/domain/TimeRange.js